import apiClient from '../../lib/axios';

export const fetchIecMaterialTypes = async ({ page = 1, pageSize = 10, isActive, search } = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', pageSize);
  if (typeof isActive === 'boolean') params.append('isActive', isActive);
  if (search) params.append('search', search);
  const { data } = await apiClient.get(`/api/iec-material-types?${params.toString()}`);
  return data;
};

export const fetchActiveIecMaterialTypes = async () => {
  const { data } = await apiClient.get('/api/iec-material-types/active');
  return data;
};

export const fetchIecMaterialTypeById = async (id) => {
  const { data } = await apiClient.get(`/api/iec-material-types/${id}`);
  return data;
};

export const createIecMaterialType = async (payload) => {
  const { data } = await apiClient.post('/api/iec-material-types', payload);
  return data;
};

export const updateIecMaterialType = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/iec-material-types/${id}`, payload);
  return data;
};

export const deleteIecMaterialType = async (id) => {
  const { data } = await apiClient.delete(`/api/iec-material-types/${id}`);
  return data;
};

export default fetchIecMaterialTypes;
